import * as React from "react";
import type { Item } from "@/types/fse";

export const usePagination = (data: Item[], itemsPerPage = 50) => {
  const [currentPage, setCurrentPage] = React.useState(1);

  const { displayItems, totalPages } = React.useMemo(() => {
    const displayItems = data;
    const totalPages = Math.ceil(displayItems.length / itemsPerPage);

    return { displayItems, totalPages };
  }, [data, itemsPerPage]);

  return {
    displayItems,
    totalPages,
    setCurrentPage,
    itemsPerPage,
    currentPage,
  };
};
